import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as CodeServices from "../../../../services/CodeService";
import { useTranslation } from "react-i18next";
import CodeForm from "./codeForm.view";
import PATHS from "../../../../constants/paths";
import {
  BreadCrumb,
  ShowAlertDialog,
} from "@de-prado-dev/react-component-library";
import * as BatchService from "../../../../services/BatchService";
import * as VarietyService from "../../../../services/VarietyService";
import * as ArticleService from "../../../../services/ArticleService";
import * as ViveroService from "../../../../services/ViveroService";
import * as LocationService from "../../../../services/LocationService";
import * as SectorService from "../../../../services/SectorService";

const CodeFormContainer = ({ uuid }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});
  const [batchs, setBatchs] = useState([]);
  const [locations, setLocations] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [articles, setArticles] = useState([]);
  const [varieties, setVarieties] = useState([]);
  const [viveros, setViveros] = useState([]);
  const [code, setCode] = useState(null);

  const setInitialValues = useCallback(async (data) => {
    const dataFinal = {
      batchUuid: data.batchUuid,
      culture: data.culture,
      varietyUuid: data.varietyUuid,
      articleUuid: data.articleUuid,
      locationUuid: data.locationUuid,
      sectorUuid: data.sectorUuid,
      viveroUuid: data.viveroUuid,
      status: data.status,
    };
    await handlerOnChangeCulture(data.culture);
    await handlerOnChangeVariety(data.varietyUuid);
    await handlerOnChangeVivero(data.viveroUuid);
    await handlerOnChangeLocation(data.locationUuid);
    setInitValues(dataFinal);
    setCode(data.code);
  }, []);

  const loadData = useCallback(async () => {
    const resultItems = await BatchService.getAllBatches({
      filters: { active: true },
    });
    if (resultItems && resultItems.length > 0) {
      const dataBatch = resultItems.map((item) => {
        return {
          code: item.uuid,
          label: item.code,
        };
      });
      setBatchs(dataBatch);
    }
    const resultViveros = await ViveroService.getAllViveros({
      filters: { active: true },
    });
    if (resultViveros && resultViveros.length > 0) {
      const dataViveros = resultViveros.map((item) => {
        return {
          code: item.uuid,
          label: item.name,
        };
      });
      setViveros(dataViveros);
    }
    if (uuid) {
      const result = await CodeServices.getCode(uuid);
      if (result) {
        await setInitialValues(result);
      }
    }
  }, [setInitialValues, uuid]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        let result = undefined;

        if (uuid) {
          result = await CodeServices.updateCode(values, uuid);
        } else {
          result = await CodeServices.addCode(values);
        }

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.code.messages.update.title");
            text = t("forms.code.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.code.messages.create.title");
            text = t("forms.code.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.code.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          navigate(PATHS.CODE_LIST);
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handleOnback = () => {
    navigate(PATHS.CODE_LIST);
  };

  const handlerOnChangeCulture = async (value) => {
    const resultItems = await VarietyService.getAllVarieties({
      filters: { active: true, culture: value },
    });
    if (resultItems && resultItems.length > 0) {
      const data = resultItems.map((item) => {
        return {
          code: item.uuid,
          label: item.name,
        };
      });
      setVarieties(data);
      setArticles([]);
    } else {
      setVarieties([]);
      setArticles([]);
    }
  };

  const handlerOnChangeVariety = async (value) => {
    const resultItems = await ArticleService.getAllArticles({
      filters: { active: true, varietyUuid: value },
    });
    if (resultItems && resultItems.length > 0) {
      const data = resultItems.map((item) => {
        return {
          code: item.uuid,
          label: item.name,
        };
      });
      setArticles(data);
    }
  };

  const handlerOnChangeVivero = async (value) => {
    const resultItems = await LocationService.getAllLocations({
      filters: { active: true, viveroUuid: value },
    });
    if (resultItems && resultItems.length > 0) {
      const data = resultItems.map((item) => {
        return {
          code: item.uuid,
          label: item.name,
        };
      });
      setLocations(data);
      setSectors([]);
    } else {
      setLocations([]);
      setSectors([]);
    }
  };

  const handlerOnChangeLocation = async (value) => {
    const resultItems = await SectorService.getAllSectors({
      filters: { active: true, locationUuid: value },
    });
    if (resultItems && resultItems.length > 0) {
      const data = resultItems.map((item) => {
        return {
          code: item.uuid,
          label: item.name,
        };
      });
      setSectors(data);
    }
  };

  return (
    <CodeForm
      edit={uuid ? true : false}
      initialValues={initValues}
      onSubmit={handleSubmit}
      onback={handleOnback}
      batchs={batchs}
      locations={locations}
      sectors={sectors}
      articles={articles}
      varieties={varieties}
      viveros={viveros}
      code={code}
      onChangeCulture={handlerOnChangeCulture}
      onChangeVariety={handlerOnChangeVariety}
      onChangeVivero={handlerOnChangeVivero}
      onChangeLocation={handlerOnChangeLocation}
    />
  );
};

CodeFormContainer.propTypes = {
  t: PropTypes.any,
};

export default CodeFormContainer;
